import React, { useState, useEffect } from "react";
// eslint-disable-next-line
import New1 from "../../assets/dolcevita.jpg";
import New2 from "../../assets/brooks.jpg";
import New3 from "../../assets/gogolady.jpg";
import "./News.css";
import { motion } from "framer-motion";

const News2 = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible((prevVisible) => !prevVisible);
    }, 500); // Réglez la durée du clignotement en millisecondes

    return () => {
      clearInterval(interval);
    };
  }, []);

  // Fonction pour empêcher les actions de copier, coller et glisser-déposer
  const preventDefaultActions = (e) => {
    e.preventDefault();
  };

  return (
    <div
      className="max-sm:pt-[30px] max-sm:h-[100%] md:h-[100%] h-[100%] py-6 flex items-center justify-center bg-black text-white max-sm:flex-col overflow-hidden"
      id="news"
    >
      <div className="flex flex-col">
        <h2 className="text-center font-oswald text-[2rem] mb-3 pt-5 max-sm:text-[30px]">
          ACTUALITÉS
        </h2>
        <div className="border border-solid border-1 border-fe955a bg-fe955a max-w-[150px] mx-auto"></div>

        <div className="flex justify-center mt-2">
          <div className="flex flex-col gap-y-[100px]">
            {/* NEW 1 */}
            <div className=" w-full">
              <div className="flex max-sm:pt-5 gap-9 justify-center items-center max-lg:flex-col max-sm:flex-col">
                <div>
                  <img
                    className="w-[500px] max-sm:mx-auto max-sm:max-w-[300px] mr-2"
                    src={New1}
                    alt=""
                    onContextMenu={preventDefaultActions} // Empêche le clic droit
                    onDragStart={preventDefaultActions} // Empêche le glisser-déposer
                    onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
                  />
                </div>

                <div className="flex flex-col max-sm:items-center">
                  <motion.h1
                    className="text-[40px] font-openSans max-sm:text-[30px]"
                    variants={{
                      hidden: { opacity: 0 },
                      show: {
                        opacity: 1,
                        transition: { duration: 0.5, yoyo: Infinity },
                      },
                    }}
                    initial="hidden"
                    animate={isVisible ? "show" : "hidden"}
                    viewport={{ once: false, amount: 0.3 }}
                    style={{ color: "#14a0fe" }}
                  >
                    ALBUM INÉDIT !
                  </motion.h1>
                  <div className="max-w-[600px]  max-lg:max-w-[300px]">
                    <p className="font-openSans text-[23px] max-sm:text-sm max-sm:text-center text-justify font-bold text-white opacity-90 mb-3 leading-6">
                      FRANCK FERNANDEL -{" "}
                      <span className="italic">C’est toi ma dolce vita </span>
                    </p>
                    <p className="font-openSans text-justify text-[20px] max-sm:text-[16px] max-sm:text-center font-bold text-white opacity-90 mb-3 leading-6">
                      Sortie le 20 juin 2025 !
                    </p>
                    <p className="text-[16px] text-justify font-openSans leading-7">
                      Revivez la chaleur et l’insouciance des années 70 grâce à
                      la voix de crooner de Franck Fernandel, entre tubes et
                      chansons inédites : « L’amour interdit », « Sweetie chérie
                      my love », « Les amoureux du soleil », « La vie est
                      rétro »…Pas moins de 23 titres remasterisés en HD
                      constituent cette édition Deluxe disponible à partir du 20
                      juin 2025 sur toutes les plateformes.
                      <br />
                      <span className="italic">
                        En partenariat avec Musiques & Solutions et Universal
                        Music.
                      </span>
                    </p>

                    <div className="flex flex-col justify-start">
                      <div className="max-sm:mx-auto news-link">
                        <a
                          href="https://franckfernandel.lnk.to/cesttoimadolcevita"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Écouter
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* NEW 2 */}
            <div className=" w-full">
              <div className="flex max-sm:pt-5 max-lg:flex-col gap-9 justify-center items-center max-sm:flex-col ">
                <div>
                  <img
                    className="w-[300px] max-sm:mx-auto max-sm:max-w-[300px] mr-2"
                    src={New2}
                    alt=""
                    onContextMenu={preventDefaultActions} // Empêche le clic droit
                    onDragStart={preventDefaultActions} // Empêche le glisser-déposer
                    onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
                  />
                </div>

                <div className="flex flex-col max-sm:items-center">
                  <motion.h1
                    className="text-[22px] font-openSans max-sm:text-[20px]"
                    style={{ color: "#fe90ab" }}
                  >
                    EP BOOGIE-POP !
                  </motion.h1>
                  <div className="max-w-[600px] max-lg:max-w-[300px]">
                    <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-justify font-bold text-white opacity-90 mb-3 leading-6">
                      BROOKS - <span className="italic">What a paradise !</span>
                    </p>
                    <p className="font-openSans text-justify text-[16px] max-sm:text-[16px] max-sm:text-center font-bold text-white opacity-90 mb-3 leading-6">
                      Une pépite vintage disponible sur toutes les plateformes.
                    </p>
                    <p className="text-[16px] text-justify font-openSans leading-7">
                      Disponible pour la première fois en version remasterisée
                      depuis sa sortie en 1982, « What a paradise ! » nous
                      ramène aux inoubliables tubes feel-good des eighties !
                      Dans la mouvance des Buggles, Cars ou encore Katrina &amp;
                      The Wave, cette chanson boogie-pop est interprétée par un
                      certain Brooks, derrière lequel se cache le frenchy F.R.
                      David, futur interprète du hit planétaire « Words » !
                      <br /> Découvrez cet EP, en passe de devenir culte…
                    </p>

                    <div className="flex flex-col justify-start">
                      <div className="max-sm:mx-auto news-link">
                        <a
                          href="https://open.spotify.com/intl-fr/artist/0u5R4FYFVtfj4POuUwc5CW"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Écouter
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* NEW 3 */}
            <div className=" w-full">
              <div className="flex max-sm:pt-5 gap-9 justify-center items-center max-sm:flex-col max-sm:pb-5 max-lg:flex-col">
                <div>
                  <img
                    className="w-[300px] max-sm:mx-auto max-sm:max-w-[300px] mr-2"
                    src={New3}
                    alt=""
                    onContextMenu={preventDefaultActions} // Empêche le clic droit
                    onDragStart={preventDefaultActions} // Empêche le glisser-déposer
                    onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
                  />
                </div>

                <div className="flex flex-col max-sm:items-center">
                  <motion.h1
                    className="text-[22px] font-openSans max-sm:text-[20px]"
                    viewport={{ once: false, amount: 0.3 }}
                    style={{ color: "#cf722d" }}
                  >
                    EP DISCO - FUNK !
                  </motion.h1>
                  <div className="max-w-[600px]  max-lg:max-w-[300px]">
                    <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-justify font-bold text-white opacity-90 mb-3 leading-6">
                      DELAHAYE SISTERS -{" "}
                      <span className="italic">Gogo Lady</span>
                    </p>
                    <p className="font-openSans text-justify text-[16px] max-sm:text-[16px] max-sm:text-center font-bold text-white opacity-90 mb-3 leading-6">
                      Girl power from the 70’s !
                    </p>
                    <p className="text-[16px] text-justify font-openSans leading-7">
                      Avant d’enflammer les charts de 1976 avec « Gogo Lady »,
                      reprise frenchy du hit de Johnny Taylor « Disco Lady »,
                      les sœurs Delahaye sont les It-girls des cabarets chics,
                      de Saint-Tropez à Paris, avec leur show de
                      danseuses-acrobates. Le temps d’un unique 45 tours, elles
                      deviennent les Delahaye Sisters. Aux lyrics, les paroliers
                      de Bardot, Dalida, Hardy ; au beat soul-funk, l’arrangeur
                      de Polnareff et Claude François. Une success-story made in
                      70’s à redécouvrir en version remasterisée !
                    </p>

                    <div className="flex flex-col justify-start">
                      <div className="max-sm:mx-auto news-link">
                        <a
                          href="https://open.spotify.com/intl-fr/artist/4PtXpeCErGyDYTgBXti5vh"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Écouter
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default News2;
